import request from "@/core/services/request";

export function checkOrderStatus(data) {
  return request({
    url: "/api/v1/pay/check/status/",
    method: "post",
    data: data,
  });
}

export function postSumPrices(data) {
  return request({
    url: "/api/v1/pay/sum_prices/",
    method: "post",
    data: data,
  });
}
